import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AdminDto } from '../../dtos/admin.dto';
import { AdminService } from '../../services/admin.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { AdminType } from '../../enums/admin-type.enum';
import { AdminTypePipe } from '../../pipes/admin-type.pipe';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { UpdateAdminTypeDto } from '../../dtos/update-admin-type.dto';
import { ErrorService } from '../../../../core/services/error.service';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-edit-admin',
  imports: [
    AdminTypePipe,
    MatSelectModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    TranslocoPipe
  ],
  templateUrl: './edit-admin.dialog.html',
  styleUrl: './edit-admin.dialog.scss'
})
export class EditAdminDialog implements OnInit {
  adminTypeSelector!: FormControl;

  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    adminDto: AdminDto
  }, private adminService: AdminService, private dialogRef: MatDialogRef<EditAdminDialog>,private translocoService: TranslocoService, private errorService: ErrorService) {
  }

  get adminTypes() {
    return Object.values(AdminType);
  }

  ngOnInit() {
    this.adminTypeSelector = new FormControl(this.data.adminDto.adminType);
  }

  close(): void {
    this.dialogRef.close(false);
  }

  editAdminType(): void {
    let updateAdminTypeDto: UpdateAdminTypeDto = {
      email: this.data.adminDto.email,
      adminType: this.adminTypeSelector.value
    };

    this.adminService.updateAdminType(updateAdminTypeDto).subscribe({
      next: () => {
        this.dialogRef.close(true);
      },
      error: (error) => {
        this.errorService.handleError(error, this.translocoService.translate("error.title.edit_admin_type"));
      }
    });
  }
}
